import { Box, TableCell, TableRow, Tooltip } from "@mui/material";
import React from "react";
import TableDesign from "../../../../components/common/table/TableDesign";
import { typeTableHeadings } from "./workerAllFields";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
const TaskList = () => {
  const { userProfile } = useSelector((state: any) => state?.user);
  const { operationTasks, taskPagination } = useSelector(
    (state: any) => state.assignWorker,
  );
  // Function to calculate total distance for a task
  const getTotalDistance = (val: any) => {
    const collectionDist = (val?.collection_addresses || [])
      .map((a: any) => Number(a?.distance) || 0)
      .reduce((a: number, b: number) => a + b, 0);
    const deliveryDist = (val?.delivery_addresses || [])
      .map((a: any) => Number(a?.distance) || 0)
      .reduce((a: number, b: number) => a + b, 0);
    const returnDist = Number(val?.returning_distance) || 0;
    const totalDist = collectionDist + deliveryDist + returnDist;
    return totalDist > 0 ? totalDist.toFixed(2) : "";
  };

  const M3_TO_FT3 = 35.3147;

const getTotalVolumeInFt3 = (val: any) => {
  const totalVolume = (val?.collection_addresses || []).reduce(
    (total: number, address: any) => {
      const volume = Number(address?.volume) || 0;
      const unit = String(address?.volume_unit || "").toLowerCase();

      if (unit === "m3" || unit === "m³") {
        return total + volume * M3_TO_FT3;
      }

      // ft3 / ft³
      return total + volume;
    },
    0,
  );

  return totalVolume > 0 ? totalVolume.toFixed(2) : "";
}

  return (
    <>
      <Box
        sx={{
          bgcolor: "#fff",
          height: {
            xs: "auto",
            sm: `${operationTasks.length > 0 ? "50vh" : "auto"}`,
          },
          border: "1px solid #d1cfcf",
          borderRadius: "5px",
          padding: "0px",
          overflow: "hidden",
        }}
      >
        <TableDesign
          tableHeadings={typeTableHeadings}
          tableHeadColor={"#02906f"}
          cellColor={"#fff"}
          pagination={taskPagination}
          isLoader={false}
          stickyHeader={true}
          // ifFixedHeader={true}
          filterOption={""}
          setFilterOption={() => {}}
          extraCSS={{
            height: "calc(100%)",
          }}
        >
          {operationTasks.length > 0 ? (
            operationTasks?.map((val: any, idx: number) => {

              const taskDate =
                val?.tag === "END" ? val?.end_date_time : val?.start_date_time;

              // parse dates safely
              const start = taskDate
                ? dayjs(taskDate)
                : val?.start_time
                  ? dayjs()
                      .hour(Number(val.start_time.split(":")[0]))
                      .minute(Number(val.start_time.split(":")[1]))
                      .second(Number(val.start_time.split(":")[2] || 0))
                  : null;

              const quoteExpire = val?.quote_expires_on
                ? dayjs(val.quote_expires_on)
                : null;

              // condition: start BEFORE quote expiry
              // const isBeforeExpire =
              //   start && quoteExpire ? start.isBefore(quoteExpire) : false;

              // ✅ Check if quote has expired compared to NOW
              const isQuoteExpired =
                quoteExpire && dayjs().isAfter(quoteExpire);

              // tooltip content when quote is expired
              const tooltipTitle = (
                <Box sx={{ fontSize: 13 }}>
                  <div>
                    <strong>Warning:</strong> The quote for this task{" "}
                  </div>
                  <div>
                    expired on : {quoteExpire?.format("YYYY-MM-DD HH:mm")}
                  </div>
                </Box>
              );

              const collectionAddress = [
                val?.collection_addresses?.[0]?.street,
                val?.collection_addresses?.[0]?.town,
                val?.collection_addresses?.[0]?.county,
                val?.collection_addresses?.[0]?.postcode,
              ]
                .filter(Boolean)
                .join(", ");

              const deliveryAddress = [
                val?.delivery_addresses?.[0]?.street,
                val?.delivery_addresses?.[0]?.town,
                val?.delivery_addresses?.[0]?.county,
                val?.delivery_addresses?.[0]?.postcode,
              ]
                .filter(Boolean)
                .join(", ");

              const addressDisplay = deliveryAddress
                ? `${collectionAddress} to ${deliveryAddress}`
                : collectionAddress;

              const dismantleItems =
                val?.dismantle?.items ||
                val?.dismantle_items ||
                val?.dismantleItems ||
                [];
              const dismantleCount = Number(
                val?.dismantle?.count ??
                  val?.dismantle_count ??
                  val?.dismantleCount ??
                  dismantleItems?.length ??
                  0,
              );
              const hasDismantleData =
                dismantleCount > 0 || dismantleItems?.length > 0;

              const rowContent = (
                <TableRow
                  key={val?.id}
                  sx={{
                    cursor: "pointer",
                    marginTop: "10px",
                    padding: "4px !important",
                    borderRadius: "20px !important",
                    backgroundColor: isQuoteExpired
                      ? "rgba(255, 0, 0, 0.06)"
                      : "inherit",
                    "&:hover": {
                      backgroundColor: isQuoteExpired
                        ? "rgba(255, 0, 0, 0.12)"
                        : "#f0f0f0",
                      outline: "2px solid #f0f0f0",
                      borderRadius: "0px !important",
                      outlineOffset: "-2px !important",
                    },
                  }}
                >
                  <TableCell align="left">{idx + 1}</TableCell>
                  <TableCell style={{ minWidth: 60 }}>
                    {val?.job_title}
                    {val?.tag ? `-${val?.tag}` : ""}
                  </TableCell>
                  <TableCell>{val?.lead_id}</TableCell>
                  <TableCell>
                    {start
                      ? start
                          ?.tz(userProfile?.timezone || "UTC")
                          .format("HH:mm")
                      : "N/A"}
                    {/* {start ? dayjs.utc(start).format("HH:mm") : "N/A"} */}
                  </TableCell>
                  <TableCell style={{ minWidth: 100 }}>
                    {val?.customer_name}
                  </TableCell>
                  <TableCell>
                    {/* {(val?.collection_addresses || []).map(
                      (address: any, index: number) => (
                        <div key={address?.id || index}>
                          {address?.volume ?? ""}
                      
                        </div>
                      ),
                    )} */}

                    {getTotalVolumeInFt3(val)}
  {/* {getTotalVolumeInFt3(val) ? " ft³" : ""} */}
                  </TableCell>
                  <TableCell>
                    {val?.tenant_name ?? val?.surveyor_name}
                  </TableCell>
                  <TableCell style={{ minWidth: 300 }}>
                    {addressDisplay}
                  </TableCell>
                  <TableCell>{getTotalDistance(val)}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {hasDismantleData ? (
                      <Tooltip
                        title={
                          <Box sx={{ fontSize: 13 }}>
                            {dismantleItems?.length > 0
                              ? dismantleItems
                                  .map(
                                    (item: any) =>
                                      `${item?.item} * ${item?.quantity}`,
                                  )
                                  .join(" | ")
                              : "No items"}
                          </Box>
                        }
                        arrow
                        placement="top"
                        slotProps={{
                          tooltip: {
                            sx: {
                              background:
                                "linear-gradient(45deg, #b5d6f8, #a0d1f9)",
                              color: "#333",
                              fontSize: "13px",
                              borderRadius: "6px",
                              padding: "6px 10px",
                            },
                          },
                        }}
                      >
                        <span style={{ cursor: "pointer" }}>
                          {dismantleCount}
                        </span>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </TableCell>
                  <TableCell>
                    {val?.collection_addresses?.[0]?.paces ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.collection_addresses?.[0]?.flight_of_stairs ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.collection_addresses?.[0]?.type ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.collection_addresses?.[0]?.house_size ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.collection_addresses?.[0]?.floors ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.collection_addresses?.[0]?.lift_availability ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.collection_addresses?.[0]?.purchase_status ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.delivery_addresses?.[0]?.paces ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.delivery_addresses?.[0]?.flight_of_stairs ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.delivery_addresses?.[0]?.type ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.delivery_addresses?.[0]?.house_size ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.delivery_addresses?.[0]?.floors ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.delivery_addresses?.[0]?.lift_availability ?? ""}
                  </TableCell>
                  <TableCell>
                    {val?.delivery_addresses?.[0]?.purchase_status ?? ""}
                  </TableCell>
                </TableRow>
              );

              return isQuoteExpired ? (
                <Tooltip
                  key={val?.job_id ?? val?.id ?? idx}
                  title={tooltipTitle}
                  arrow
                  placement="top"
                  slotProps={{
                    tooltip: {
                      sx: {
                        background: "linear-gradient(45deg, #ff6b6b, #f94d6a)",
                        color: "#fff",
                        fontSize: "13px",
                        fontWeight: 500,
                        borderRadius: "8px",
                        padding: "8px 12px",
                        boxShadow: "0px 2px 8px rgba(0,0,0,0.25)",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#f94d6a",
                      },
                    },
                  }}
                >
                  {rowContent}
                </Tooltip>
              ) : (
                rowContent
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={20}>
                <Box
                  sx={{
                    height: "10vh",
                    display: "flex",
                    // alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  {"No Tasks Found."}
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableDesign>
      </Box>
    </>
  );
};
export default TaskList;
